import { render, staticRenderFns } from "./AssignClinician.vue?vue&type=template&id=5f81261c&"
import script from "./AssignClinician.vue?vue&type=script&lang=js&"
export * from "./AssignClinician.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports